import React from 'react';
import { Select, Space } from 'antd';
import { DesktopOutlined, MoonOutlined, SunOutlined } from '@ant-design/icons';
import { useTheme } from '../contexts/ThemeContext';

const ThemeSwitcher: React.FC = () => {
  const { mode, setMode } = useTheme();
  return (
    <Select
      aria-label="外观主题"
      value={mode}
      onChange={setMode}
      style={{ width: 144, height: 44 }}
      options={[
        { value: 'light', label: <Space><SunOutlined />浅色模式</Space> },
        { value: 'dark', label: <Space><MoonOutlined />深色模式</Space> },
        { value: 'system', label: <Space><DesktopOutlined />跟随系统</Space> },
      ]}
    />
  );
};

export default ThemeSwitcher;
